var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_vm._m(0),_c('div',{staticClass:"timer"},[_c('timer')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-text"},[_c('div',[_vm._v(" 北京金融街教学数据系统 ")])])
}]

export { render, staticRenderFns }